// extracted by mini-css-extract-plugin
export default {"productDescription":"gaa-z","featuredDescription":"haa-z","description":"iaa-z","more":"jaa-z","descriptionSku":"kaa-z"};